import { render, staticRenderFns } from "./perbelanjaanKomposisi.vue?vue&type=template&id=af8ce168&scoped=true"
import script from "./perbelanjaanKomposisi.vue?vue&type=script&lang=js"
export * from "./perbelanjaanKomposisi.vue?vue&type=script&lang=js"
import style0 from "./perbelanjaanKomposisi.vue?vue&type=style&index=0&id=af8ce168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8ce168",
  null
  
)

export default component.exports